/**
 * NPM Proxy Manager — widget-first (2.1).
 * Panels: pages/modules/npm/panels.tsx
 * Catalog: module-ui-catalog → same widgets on /infra/nodes/:id
 * Phone: dedicovaná plocha /phone/proxy (MCP-only, kvalitní submenu).
 */
import { Navigate } from 'react-router-dom';
import { requireModuleUi } from '../../widgets/module-ui-catalog';
import { useIsPhoneLayout } from '../../lib/ui-layout';
import { ModuleWorkspace } from './ModuleWorkspace';

const DEF = requireModuleUi('npm');

export default function NpmModule() {
  const isPhone = useIsPhoneLayout();
  if (isPhone) return <Navigate to='/phone/proxy' replace />;
  return <ModuleWorkspace def={DEF} hideHeader defaultTab='hosts' />;
}
